const RecordStage = {
	DETECT: 1, // 检测阶段
	IMAGE_DISPLAY: 2, // 图片显示阶段
	REPORT_GENERATING: 3, // 报告生成阶段
	REPORT_ERROR: 4, // 报告生成错误
	REPORT_COMPLETE_LATER: 5, // 报告稍后生成
	NETWORK_ERROR: 6, // 网络错误
	REPORT_COMPLETE: 7, // 报告生成完成
	SUBMITTING_DATA_ERROR: 8, // 提交数据错误
	FRONTEND_ERROR: 9, // 前端错误
	USER_EXPIRE: 10, // token过期
	BACKEND_ERROR: 11, // 后端错误

}
const stressColorList = {

	green: (alpha = 1) => `rgba(0, 204, 126, ${alpha})`,
	red: (alpha = 1) => `rgba(196, 1, 27, ${alpha})`,
	yellow: (alpha = 1) => `rgba(255, 175, 38, ${alpha})`,
	orange: (alpha = 1) => `rgba(245, 105, 36, ${alpha})`,
	redOrange: (alpha = 1) => `linear-gradient(90deg, rgba(196, 1, 27,${alpha}) 0%,rgba(245, 105, 36,${alpha}) 100%)`,
	orangeRed: (alpha = 1) => `linear-gradient(90deg, rgba(245, 105, 36,${alpha}) 0%, rgba(196, 1, 27,${alpha}) 100%)`,
	yellowOrange: (alpha = 1) => `linear-gradient(90deg,rgba(251, 204, 3,${alpha}) 0%,  rgba(245, 105, 36,${alpha}) 100%)`,

}
const trendChartColorList = {
	green: stressColorList.green(0.2),
	red: stressColorList.red(0.2),
	yellow: stressColorList.yellow(0.2),
	orange: stressColorList.orange(0.2),
	redOrange: stressColorList.redOrange(0.2),
	orangeRed: stressColorList.orangeRed(0.2),
	yellowOrange: stressColorList.yellowOrange(0.2),
}
const getProcessColor = (colorString, opacityValue) => {
	return stressColorList[colorString](opacityValue)
}

const HRV_QUESTIONNAIRE_POSITION = {
  BEFORE_CHECK: 1,
  AFTER_CHECK: 2
}
export { RecordStage,HRV_QUESTIONNAIRE_POSITION, stressColorList, trendChartColorList, getProcessColor }
